/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown> }} Plan_Card_Total_MonthlyInputs */



/**
* | output |
* | --- |
* | "/mo for {seats} seats" |
*
* @param {Plan_Card_Total_MonthlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_total_monthly = /** @type {((inputs: Plan_Card_Total_MonthlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Total_MonthlyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`/Mo. für ${i?.seats} Plätze`)
	return /** @type {LocalizedString} */ (`/mo for ${i?.seats} seats`)
});